import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type BadgeVariant = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info';
export type BadgeSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'app-atom-badge',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
})
export class BadgeComponent {
  @Input() variant: BadgeVariant = 'primary';
  @Input() size: BadgeSize = 'md';
  @Input() rounded: boolean = true;
  @Input() additionalClasses: string = '';

  get badgeClasses(): string {
    const classes = ['inline-flex', 'items-center', 'font-medium'];

    const variantMap: Record<BadgeVariant, string> = {
      primary: 'bg-primary-100 text-primary-800',
      secondary: 'bg-secondary-100 text-secondary-800',
      success: 'bg-success-100 text-success-800',
      danger: 'bg-danger-100 text-danger-800',
      warning: 'bg-warning-100 text-warning-800',
      info: 'bg-info-100 text-info-800',
    };

    const sizeMap: Record<BadgeSize, string> = {
      sm: 'px-2 py-0.5 text-xs',
      md: 'px-2.5 py-0.5 text-sm',
      lg: 'px-3 py-1 text-base',
    };

    classes.push(variantMap[this.variant]);
    classes.push(sizeMap[this.size]);

    if (this.rounded) {
      classes.push('rounded-full');
    } else {
      classes.push('rounded');
    }

    if (this.additionalClasses) {
      classes.push(this.additionalClasses);
    }

    return classes.join(' ');
  }
}
